// extracted by mini-css-extract-plugin
export default {"login_container":"buyer_login_container__Vx371"};